import api from '../../plugins/api';

const getModels = (params) => {
  return api.get('/api/crm/cars/getModels', params);
};

export default getModels;
